// exp_PORTFOLIO-53635_next_line
import { getAllSourcesChecked, replaceHHWithSplitSubSources, sourcesConfigFromDto } from 'utils/campaign';
import { getArrayIntersection } from 'utils/clickme';
import { isFirstStep, isSecondStep } from 'utils/constants/campaign';

import { setNextStepForCampaignAndBanner } from 'components/CpcFlexibleCreate/CpcActions/setNextStepForCampaignAndBanner';
import { getCampaignType } from 'components/CpcFlexibleCreate/CpcForm/AdCampaignInformation/getCampaignType';

import { setIsCropImageModalVisible } from 'store/models/createBanner';
import { setCampaignAllSources, setCampaignSubSource } from 'store/models/createCampaign';
import { AppThunkAction } from 'store/utils';

type SetNextStepForCopy = (
    currentStep: number,
    setSaving: (saving: boolean) => void,
    dashboardRoute: string
) => AppThunkAction;

export const setNextStepForCopy: SetNextStepForCopy = (currentStep, setSaving, dashboardRoute) => {
    return (dispatch, getState) => {
        const state = getState();
        const { adSource, campaignType } = state.createCampaign;
        const { isCropsSaved, bannerLink } = state.createBanner;
        const callNextStepForCampaignAndBanner = () =>
            dispatch(setNextStepForCampaignAndBanner(currentStep, setSaving, dashboardRoute));

        if (isFirstStep(currentStep)) {
            if (!isCropsSaved) {
                void dispatch(setIsCropImageModalVisible(true));
                return Promise.resolve();
            }

            if (bannerLink && campaignType === null) {
                void dispatch(getCampaignType());
                return Promise.resolve();
            }

            return callNextStepForCampaignAndBanner();
        }

        if (isSecondStep(currentStep)) {
            return callNextStepForCampaignAndBanner().then(() => {
                const { createCampaign } = getState();
                // exp_PORTFOLIO-53635_start
                const permittedSources = replaceHHWithSplitSubSources(
                    getArrayIntersection(adSource, createCampaign.adSource),
                    createCampaign.adSourcesConfig
                );
                // exp_PORTFOLIO-53635_end
                const { enabledSources } = sourcesConfigFromDto(createCampaign.adSourcesConfig);
                const allSourcesChecked = getAllSourcesChecked(permittedSources, enabledSources);

                const actions = [setCampaignSubSource(permittedSources), setCampaignAllSources(allSourcesChecked)];

                dispatch(actions);
            });
        }

        return callNextStepForCampaignAndBanner();
    };
};
